import React, { useState } from "react";
import Button from '@mui/material/Button';
import CreateIcon from '@mui/icons-material/Create';
import Edit from './Edit';

export default function BillingInfo(props) {
  const emptyBillingInfo = {address: {}, email: ''};
  const [billingInformation, setBillingInformation] = useState(props.billingInformation || emptyBillingInfo);
  const [editing, setEditing] = useState(false);

  const onUpdate = (updated) => {
    setEditing(false);
    setBillingInformation(updated);
    props.onUpdate();
  };

  if (editing) {
    return <Edit onClose={onUpdate} billingInformation={billingInformation}/>;
  }

  const renderAddress = ({ address }) => {
    const parts = [address.city, address.state, address.postal_code, address.country].filter(Boolean);
    if (parts.length === 0) return null;

    return (
      <div>
        {address.city}{address.city && address.state && ', '}
        {address.state} {address.postal_code} {address.country}
      </div>
    );
  };

  const hasAddressData = billingInformation.address && 
    Object.values(billingInformation.address).some(val => val && val.toString().trim() !== '');

  return (
    <div className="BillingInfoSection">
      <h5 className="page-header">Billing Information</h5>
      <div className="billing-section-content">
        <div className="BillingInfo Flex Flex-direction--row" style={{ marginBottom: '15px' }}>
          <div style={{ flexBasis: '160px' }}><span className="TextLabel">Email</span></div>
          <div className="BillingInfo-address">{billingInformation.email}</div>
        </div>
        {hasAddressData && <div className="BillingInfo Flex Flex-direction--row" style={{ marginBottom: '15px' }}>
          <div style={{ flexBasis: '160px' }}><span className="TextLabel">Address</span></div>
          <div className="BillingInfo-address">
            <address>
              <div>{billingInformation.address.line1}</div>
              <div>{billingInformation.address.line2}</div>
            </address>
            <div>
              {renderAddress(billingInformation)}
            </div>
          </div>
        </div>}
        <div style={{ marginTop: '25px' }}>
          <Button color="primary" variant="contained" startIcon={<CreateIcon/>} onClick={() => setEditing(true)}>Update billing information</Button>
        </div>
      </div>
    </div>
  );
}
